import Link from "next/link";
import styles from "./BannerV2.module.css";

type BannerV2Props = {
  text: string;
  linkText: string;
  linkHref: string;
};

export const BannerV2 = ({ text, linkText, linkHref }: BannerV2Props) => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>
        {text}{" "}
        {linkHref.trim() && linkText.trim() ? (
          <Link href={linkHref}>{linkText}</Link>
        ) : null}
      </p>
    </div>
  );
};
